export interface IApplicationState {
    lockedReelId: number;
    lockedReelArr: any;
    showLockedReel: boolean;
}

const initialState: IApplicationState = {
    lockedReelId: -1,
    lockedReelArr: [],
    showLockedReel: false
};

export enum actionTypes {
    SHOW_LOCKED_REEL = '@@lockedReel/SHOW_LOCKED_REEL',
    RESET_LOCKED_DATA = '@@lockedReel/RESET_LOCKED_DATA',
    SET_LOCKED_REEL_ARRAY = '@@lockedReel/SET_LOCKED_REEL_ARRAY',
}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const {lockedReelArr} = action;
    switch (action.type) {
        case actionTypes.SHOW_LOCKED_REEL:
            return {
                ...state, showLockedReel: true
            };
        case actionTypes.SET_LOCKED_REEL_ARRAY:
            return {
                ...state, lockedReelArr: lockedReelArr
            };
        
        case actionTypes.RESET_LOCKED_DATA:
            return {
                ...state, showLockedReel: false
            };
        

        default:
            return state;
    }
}

export const actions = {
    setShowLockedReel: (): any => ({type: actionTypes.SHOW_LOCKED_REEL}),
    resetLockedData: (): any => ({type: actionTypes.RESET_LOCKED_DATA}),
    setLockedReelData: (lockedReelArr: any): any => ({type: actionTypes.SET_LOCKED_REEL_ARRAY, lockedReelArr}),
};
